import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useConfig } from 'wagmi'

import { stusdsRiskParametersQueryOptions } from '@/features/savings/dialogs/common/logic/stusdsRiskParameters'
import { stusdsWithdrawDataQueryOptions } from '@/features/savings/dialogs/withdraw/logic/stusds/stusdsWithdrawDataQuery'

export interface UsePrefetchStusdsDataParams {
  chainId: number
  enabled: boolean
}

export function usePrefetchStusdsData({ chainId, enabled }: UsePrefetchStusdsDataParams): void {
  const queryClient = useQueryClient()
  const wagmiConfig = useConfig()

  useEffect(() => {
    if (enabled) {
      void queryClient.prefetchQuery(stusdsRiskParametersQueryOptions({ wagmiConfig, chainId }))
      void queryClient.prefetchQuery(stusdsWithdrawDataQueryOptions({ wagmiConfig, chainId }))
    }
  }, [queryClient, wagmiConfig, chainId, enabled])
}
